import React, { useMemo, useState } from "react";
import DetailsTable from "./DetailsTable";
import TextLimit from "Api/TextLimit";
import { useControlshermContext } from "../context/ControlshermContext";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { Button, Collapse } from "reactstrap";

export default function Details() {
	const { details: data } = useControlshermContext();
	const [isCollapsed, setIsCollapsed] = useState(true);

	const toggleCollapsed = () => setIsCollapsed(prev => !prev);
	const firstTableColumns = useMemo(() => [
		{
			header: "Vervanger",
			accessorFn: (prop) => {
				const { firstName, middleName, lastName } = prop ?? {};
				return window.innerWidth > 1250
					? TextLimit.AfwezigeLimitOptionOne(firstName, middleName, lastName)
					: TextLimit.AfwezigeLimitOptionTwo(firstName, middleName, lastName);
			},
			cell: (prop) => <>{prop.getValue() ?? "-"}</>,
		},
		{
			header: "Afwezige",
			accessorFn: (prop) => {
				const { firstName, middleName, lastName } = prop?.absent ?? {};
				if (!lastName || !firstName) return "-";

				return window.innerWidth > 1250
					? TextLimit.AfwezigeLimitOptionOne(firstName, middleName, lastName)
					: TextLimit.AfwezigeLimitOptionTwo(firstName, middleName, lastName);
			},
			cell: (prop) => <>{prop.getValue()}</>,
		},
		{
			header: "Code",
			accessorKey: "code",
			cell: (prop) => {
				const abbr = prop.getValue()?.name;
				return <>{abbr ?? "-"}</>;
			},
		},
		{
			header: "Afstand (Km)",
			accessorKey: "km",
			cell: (props) => <>{props.getValue() ?? "-"}</>,
		}

	]);

	const secondTableColumns = useMemo(() => [
		{
			header: "Mobiele nummer",
			accessorKey: "mobileNumber",

		},
		{
			header: "E-Mail",
			accessorKey: "email",

		},

		{
			header: "Prive nummer",
			accessorKey: "phoneNumber",

		},
		{
			header: "Woonplaats",
			accessorKey: "community",
			cell: (props) => {
				const { name } = props.row.original?.community ?? {};
				return <>{name ?? "-"}</>;
			},
		},
	]);

	return (
		<div className="details">
			<div className="details__avatar">
				{data && data?.photo ? (
					<img src={data.photo} alt="avatar" />
				) : (
					<div className="empty"></div>
				)}
			</div>

			<div className="details__container w-100">
				<DetailsTable columns={firstTableColumns} data={data} className="details__table" />
				<Collapse isOpen={!isCollapsed} mountOnEnter>
					<DetailsTable columns={secondTableColumns} data={data} className="details__table" />
				</Collapse>
				<div className="text-center mt-2 d-flex justify-content-center pb-3">
					<Button
						outline
						className="btn-xs btn-table-show btn-color-style meer-btn"
						color="secondary"
						onClick={toggleCollapsed}
					>
						{isCollapsed ? (
							<>
								<IoIosArrowDown fontSize="12px" color="secondary" /> Meer
							</>
						) : (
							<>
								<IoIosArrowUp fontSize="12px" color="secondary" /> Minder
							</>
						)}
					</Button>
				</div>
			</div>
		</div>
	);
}
